import { extendTheme, type ThemeConfig } from "@chakra-ui/react";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";
import "@fontsource/montserrat/800.css";
import "@fontsource/montserrat/900.css";
// Brand fonts for company logos/wordmarks in the Experience section
import "@fontsource/inter/700.css";
import "@fontsource/nunito-sans/800.css";
import "@fontsource/fredoka/600.css";

const config: ThemeConfig = {
  initialColorMode: "dark",
  useSystemColorMode: false,
};

const colors = {
  brand: {
    bg: "#0c0c0d",
    surface: "#151517",
    surfaceAlt: "#1c1c1f",
    border: "rgba(255, 255, 255, 0.08)",
    text: "#f5f5f4",
    muted: "#98999c",
    accent: "#f5c518",
    accentMuted: "rgba(245, 197, 24, 0.15)",
  },
};

const theme = extendTheme({
  config,
  colors,
  fonts: {
    heading: `'Montserrat', sans-serif`,
    body: `'Montserrat', sans-serif`,
  },
  styles: {
    global: {
      "html, body": {
        backgroundColor: "brand.bg",
        color: "brand.text",
        scrollBehavior: "smooth",
      },
      "::selection": {
        backgroundColor: "brand.accent",
        color: "brand.bg",
      },
    },
  },
});

export default theme;
